export const userClicksPrevArrow = () => ({
  type: 'User Clicks Prev Arrow',
});
export const userClicksNextArrow = () => ({
  type: 'User Clicks Next Arrow',
});
export const userClicksDotButton = dotIndex => ({
  type: 'User Clicks Dot Button',
  data: {
    dot_index: dotIndex,
  },
});
export const userClicksThumbnail = thumbIndex => ({
  type: 'User Clicks Thumbnail',
  data: {
    thumbnail_index: thumbIndex,
  },
});
